import { publicEnv } from '@config/publicEnv';

export const novapayId = 'novapay-widget';

interface paymentIntentData {
  widget_data: string;
  error_code: string;
  payment_intent_id: string;
}

interface InitNovapay {
  data: paymentIntentData;
  containerId: string;
  lightMode?: boolean;
}

const injectNovapayScript = (document: any, src: string) => {
  const isNovapayScriptInjected = document.getElementById(novapayId); // prevent multiple injections

  if (!isNovapayScriptInjected) {
    const novapayDiv = document.createElement('div');
    novapayDiv.setAttribute('id', novapayId);

    const script = document.createElement('script');
    script.type = 'module';
    script.defer = true;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = src;
    script.id = `${novapayId}-script`;

    document.body.appendChild(novapayDiv);
    document.body.appendChild(script);
  }
};

export const loadNovapayWidget = async (data: any, document: any) => {
  const scriptSrc = publicEnv.PNC_UI_WIDGET_URL;

  await injectNovapayScript(document, scriptSrc);

  const novapayOptions: InitNovapay = {
    containerId: novapayId,
    data
  };

  (function init() {
    (window as any).initFortePaymentsWidget
      ? (window as any).initFortePaymentsWidget(novapayOptions)
      : setTimeout(init, 10);
  })();
};

export const unmountWidget = () => {
  const novapayWidgetTag = document.getElementById(novapayId);
  novapayWidgetTag && novapayWidgetTag.remove();
  const novapayScript = document.getElementById(`${novapayId}-script`);
  novapayScript && novapayScript.remove();
};
